import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ITransactionLine } from '../interfaces/transaction-line';
import { ITransactionLinesFilter } from '../interfaces/transaction-lines-filter';
import { ReadService } from './read.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { PriceDetailsOptionsDTO } from '../interfaces/price-details-options';

@Injectable({ providedIn: 'root' })
export class TransactionLinesService extends ReadService<
  ITransactionLine,
  ITransactionLinesFilter
> {
  url = '/api/transactionlines';
  entityTitle = 'Transaction Line';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getSupplierInvoiceTransactions(invoiceId: number): Promise<any> {
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getSupplierInvoiceTransactions?invoiceId=${invoiceId}`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  getUninvoicedSupplierTransactions(filter: ITransactionLinesFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getUninvoicedSupplierTransactions`, { params: params }),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  getTransactionTypes() {
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getTransactionTypes`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  getPriceDetailsOptions(jobId: number, orderId: number): Promise<PriceDetailsOptionsDTO> {
    return this.http
      .get<PriceDetailsOptionsDTO>(`${this.url}/get-price-details-options/${jobId}/${orderId}`)
      .toPromise();
  }
}
